// Trusted Value Icons JS
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(max-width: 800px)').matches) return;

  var swiperWrapper = document.querySelector('.trust-value-icons .swiper-wrapper');
  if (!swiperWrapper) return;
  var bannerInterval = swiperWrapper.getAttribute('data-interval');
  var bannerSpeed = swiperWrapper.getAttribute('data-transition');

  window.luxoRunNearElement('.trust-value-icons .swiper-container', function () {
    window.luxoLoadSwiper().then(function () {
      var swiper = new Swiper('.trust-value-icons .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true, // Enables infinite scrolling
        autoplay: {
          delay: bannerInterval,
          disableOnInteraction: false,
        },
        speed: bannerSpeed,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 40,
          }
        }
      });
    });
  }, { fallbackDelay: 30000 });
});
